var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "option-dialog",
          staticStyle: { "margin-top": "12vh" },
          attrs: {
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.typeTitle + "分类"))
          ]),
          _c(
            "el-form",
            {
              ref: "SensitiveWordForm",
              staticClass: "xForm",
              attrs: {
                model: _vm.showParams,
                "label-width": "110px",
                center: ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分类名称", prop: "wordTypeName" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      size: "medium",
                      autocomplete: "off",
                      maxlength: "30",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.showParams.wordTypeName,
                      callback: function($$v) {
                        _vm.$set(_vm.showParams, "wordTypeName", $$v)
                      },
                      expression: "showParams.wordTypeName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "el-tags-wrap",
                  attrs: { label: "涉及范围", prop: "userId" }
                },
                [
                  _vm._l(_vm.userMembenNames, function(item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.id,
                        staticStyle: { "margin-right": "4px" },
                        attrs: { closable: "", type: "small" },
                        on: {
                          close: function($event) {
                            return _vm.delSelectedHandle(item)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(item.name) + " ")]
                    )
                  }),
                  _c("el-checkbox", { attrs: { value: _vm.checked } }, [
                    _vm._v("外部联系人(客户)")
                  ])
                ],
                2
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { size: "small" },
                  on: { click: _vm.cancel }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("StaffTree", {
        attrs: {
          title: "添加成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.userMenberList
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }